class MessageTickerScroller extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)

    this.setupTickerSpeed()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupTickerSpeed () {
    const tickerWidth = this.els.items.element.offsetWidth / 50
    this.style.setProperty('--Ticker_Speed', tickerWidth)
  }
}

if (!customElements.get('message-ticker-scroller')) {
  customElements.define('message-ticker-scroller', MessageTickerScroller)
}
